import { render } from "./WisdomOfParenting.vue?vue&type=template&id=bc77bbb2"
import script from "./WisdomOfParenting.vue?vue&type=script&lang=js"
export * from "./WisdomOfParenting.vue?vue&type=script&lang=js"

import exportComponent from "/home/metabrain/withyou/djvue/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__